import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { QuickSearchResult } from '@lassi/webapp-shared';
import {} from '@lassi/webapp-shared-pipes';

@Component({
  selector: 'lassi-quick-search-result-item',
  imports: [MatListModule],
  template: `
    <span class="result-title ultra-small-bold">
      {{ resultType() }}
    </span>
    <span class="result-label mat-label-medium" [innerHTML]="displayText()">
    </span>
  `,
  styles: `
    span {
      display: block;
    }
    .result-title {
    }

    .result-label {
      color: black;
      padding-left: 0.5rem;
      margin-top: -4px;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuickSearchResultItemComponent {
  readonly result = input.required<QuickSearchResult>();
  readonly query = input.required<string>();

  readonly resultType = computed(() => {
    switch (this.result().type) {
      case 'address_pfi':
        return 'address';
      case 'place':
        return 'feature';
      default:
        return this.result().type;
    }
  });

  readonly resultName = computed(() => {
    const result = this.result();

    switch (result.type) {
      case 'survey_label':
        return result.text;

      case 'survey_mark':
        return `${result.nine_fig} - ${result.name}`;

      case 'lga':
      case 'locality':
      case 'parish':
      case 'township':
        return result.name;

      case 'road':
        return `${result.name}, ${result.locality}`;

      case 'property':
        return `${result.pfi} - ${result.view_pfi}`;

      case 'parcel':
        return `${result.pfi} - ${result.view_pfi} - ${result.spi}`;

      case 'address':
        return result.address;

      case 'place':
        return `${result.display_text} (${result.feature_description})`;

      case 'address_pfi':
        return `${result.pfi ?? result.doc_id} - ${result.display_text}`;

      default:
        return 'Unknown result type';
    }
  });

  readonly displayText = computed(() => {
    const result = this.resultName();
    if (!result) return result;

    let display = '';

    let startIndex = 0;
    for (const match of result.matchAll(new RegExp(this.query(), 'gi'))) {
      display += result.slice(startIndex, match.index);
      display +=
        '<b>' +
        result.slice(match.index, match.index + this.query().length) +
        '</b>';
      startIndex = match.index + this.query().length;
    }
    display += result.slice(startIndex);
    return display;
  });
}
